export default "__VITE_ASSET__oKjTS99H__"